export const boxPaddingsSx = {
  padding: {
    xs: 18,
    sm: 24,
    lg: 36,
  },
};
export const boxXPaddings = boxPaddingsSx.padding;
export const boxYPaddings = boxPaddingsSx.padding;
